import scrollTo from '../about/scrollTo';

const scrollBackground = ({ currentTarget: { scrollY } }, positionArray) => {
	const filteredArray = positionArray.filter((value) => scrollY > value - 200);

	scrollTo(filteredArray.length || 1);
};

export default scrollBackground;



// WEBPACK FOOTER //
// ./src/js/about/scrollBackground.js